module.exports = __webpack_public_path__ + "static/img/发票管理1.9d2ab114.png";